import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import useAuthenticityToken from '@magoosh/utils/use_authenticity_token';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import GradientPill from '@test_prep/app/ai_tutor/components/gradient_pill';
import { GraduateCapIcon } from '@test_prep/app/ai_tutor/components/icons';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  toeflVersion: string;
}

export default (props: Props) => {
  const authenticityToken = useAuthenticityToken();
  const [isSwitching, setIsSwitching] = useState(false);

  const switchTo2026TOEFL = () => {
    setIsSwitching(true);

    fetch('/profile/exam_version', {
      method: 'PUT',
      body: JSON.stringify({
        authenticityToken,
        exam_version: '2026_toefl'
      })
    }).then(() => window.location.reload());
  };

  const switchToCurrentTOEFL = () => {
    setIsSwitching(true);

    fetch('/profile/exam_version', {
      method: 'PUT',
      body: JSON.stringify({
        authenticityToken,
        exam_version: ''
      })
    }).then(() => window.location.reload());
  };

  return (
    <CardLayout.Card className="d-flex flex-1" style={{ gap: 30 }}>
      <div
        className="align-items-center d-flex flex-none justify-content-center"
        style={{
          background: 'linear-gradient(to right, #26B67C, #9B51E0)',
          borderRadius: '50%',
          boxShadow: 'rgba(0, 0, 0, 0.15) 0px 4px 24px 0px, inset rgba(0, 0, 0, 0.15) 0px 0px 0px 3px',
          color: '#fff',
          height: 60,
          paddingTop: 3,
          width: 60
        }}
      >
        <FontAwesomeIcon icon="bell" style={{ fontSize: '1.5em' }} />
      </div>

      {
        props.toeflVersion === '2026_toefl' ? (
          <div className="d-flex flex-column">
            <div className="d-flex">
              <GradientPill size="sm">
                2026 TOEFL BETA
              </GradientPill>
            </div>

            <div className="align-items-md-center d-flex flex-column flex-md-row gap-s u-margin-T-s">
              <a
                className="text-bold"
                onClick={isSwitching ? null : switchToCurrentTOEFL}
                style={{ color: isSwitching ? colors.grayLight : colors.purple }}
              >
                Switch Back to Current TOEFL{isSwitching && <>...</>}
              </a>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column">
            <div className="d-flex">
              <GradientPill size="sm">
                2026 TOEFL BETA
              </GradientPill>
            </div>

            <div className="text-gray-darker u-margin-V-xxs">
              <strong>Start getting ready for the January 2026 TOEFL update!</strong>
            </div>

            {/*<div className="text-gray-light">
              <ul className="list-unstyled">
                <li>Built entirely from official questions</li>
                <li>Updated lessons on the new TOEFL format</li>
                <li>2 official, full-length practice tests (more coming soon)</li>
                <li>Unlimited speaking and writing grading (coming soon)</li>
              </ul>
            </div>*/}

            <div className="align-items-md-center d-flex flex-column flex-md-row gap-s">
              <a
                className="text-bold"
                onClick={isSwitching ? null : switchTo2026TOEFL}
                style={{ color: isSwitching ? colors.grayLight : colors.purple }}
              >
                Switch to 2026 TOEFL Prep Beta{isSwitching && <>...</>}
              </a>
            </div>
          </div>
        )
      }
    </CardLayout.Card>
  );
};
